/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
import { Component, OnDestroy, ChangeDetectionStrategy } from '@angular/core';
import { NbAuthService } from '../services/auth.service';
import { Router } from '@angular/router';

@Component({
    selector: 'nb-auth',
    styleUrls: ['./auth.component.scss'],
    template: `
    <loading></loading>
    <nb-layout class="nb_layout">
      <nb-layout-column class="nb_layout_column_smag">
        <nb-card>
          <nb-card-body class="nb_card_body">
            <div class="col-xl-4 col-lg-6 col-md-8 col-sm-10" id="login-container" [style.min-width.px]="getCustomMinWidth()" [style.max-width.px]="getCustomMaxWidth()">
              <router-outlet></router-outlet>

            </div>
          </nb-card-body>
        </nb-card>
      </nb-layout-column>
    </nb-layout>
  `,
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class NbAuthComponent implements OnDestroy {

  subscription: any;

  authenticated: boolean = false;
  token: string = '';

  // showcase of how to use the onAuthenticationChange method
  constructor(protected auth: NbAuthService, private router:Router) {

    this.subscription = auth.onAuthenticationChange()
      .subscribe((authenticated: boolean) => {
        this.authenticated = authenticated;
      });
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  getCustomMinWidth() {
    if (this.authenticated || this.router.url.includes('auth/callback')) {
      return 650;
    }
    return 450;
  }

  getCustomMaxWidth() {
    if (this.authenticated || this.router.url.includes('auth/callback')) {
      return 650;
    }
    return 450;
  }
}
